document.addEventListener("DOMContentLoaded", function () {
	// Initialize checkbox state on first load
	const addonCheckbox = document.getElementById("cart-addon-checkbox")
	if (addonCheckbox) {
		initializeCheckboxState(addonCheckbox)
	}

	// Use event delegation to handle checkbox changes
	// This ensures listeners work even after cart drawer innerHTML is replaced
	// Clicking the label will automatically trigger this change event
	document.addEventListener("change", function (e) {
		if (e.target.id === "cart-addon-checkbox") {
			handleCheckboxChange(e.target)
		}
	})

	// Watch for cart drawer DOM changes and re-initialize checkbox state
	// This handles all cart refresh scenarios without needing timeouts
	const cartDrawer = document.getElementById("Cart-Drawer")
	if (cartDrawer) {
		const observer = new MutationObserver((mutations) => {
			// Check if the cart addon checkbox exists in the mutated nodes
			const checkbox = document.getElementById("cart-addon-checkbox")
			if (checkbox) {
				// Hide loading overlay and initialize state
				hideLoadingOverlay()
				initializeCheckboxState(checkbox)
			}
		})

		// Observe changes to the cart drawer's child elements
		observer.observe(cartDrawer, {
			childList: true,
			subtree: true,
		})
	}

	// Helper functions for loading overlay
	function showLoadingOverlay() {
		const overlay = document.querySelector("[data-cart-addon-loading]")
		if (overlay) {
			overlay.classList.remove("tw:hidden")
			overlay.classList.add("tw:flex")
		}
	}

	function hideLoadingOverlay() {
		const overlay = document.querySelector("[data-cart-addon-loading]")
		if (overlay) {
			overlay.classList.remove("tw:flex")
			overlay.classList.add("tw:hidden")
		}
	}

	function handleCheckboxChange(checkbox) {
		const addonPrice = parseInt(checkbox.dataset.addonPrice) || 0
		const isChecked = checkbox.checked

		// Update visual state
		updateCheckboxVisual(isChecked)

		// Update cart subtotal display
		updateCartSubtotal(addonPrice, isChecked, checkbox)

		// Dispatch custom event for other components to listen to
		document.dispatchEvent(
			new CustomEvent("cart-addon:changed", {
				detail: {
					selected: isChecked,
					price: addonPrice,
				},
			})
		)
	}

	function updateCheckboxVisual(isChecked) {
		const checkboxVisual = document.querySelector("[data-checkbox-visual]")
		const checkmark = checkboxVisual?.querySelector("svg")

		if (checkboxVisual) {
			if (isChecked) {
				checkboxVisual.classList.add("tw:bg-black", "tw:border-black")
				checkboxVisual.classList.remove("tw:bg-white", "tw:border-gray-300")
			} else {
				checkboxVisual.classList.remove("tw:bg-black", "tw:border-black")
				checkboxVisual.classList.add("tw:bg-white", "tw:border-gray-300")
			}
		}

		if (checkmark) {
			if (isChecked) {
				checkmark.classList.add("tw:opacity-100")
				checkmark.classList.remove("tw:opacity-0")
			} else {
				checkmark.classList.remove("tw:opacity-100")
				checkmark.classList.add("tw:opacity-0")
			}
		}
	}

	async function updateCartSubtotal(addonPrice, isChecked, checkbox) {
		const { addonVariantId } = checkbox.dataset

		if (isChecked) {
			// Add addon to cart
			const data = {
				items: [
					{
						id: addonVariantId,
						quantity: 1,
					},
				],
			}
			fetch(window.Shopify.routes.root + "cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			})
				.then((response) => {
					return response.json()
				})
				.then((data) => {
					// Show loading overlay before refresh
					showLoadingOverlay()
					// Refresh cart drawer to show updated cart with addon
					const cartDrawer = document.querySelector("cart-drawer")
					if (cartDrawer) {
						cartDrawer.refresh()
						// MutationObserver will automatically hide overlay and re-initialize checkbox when DOM updates
					}
				})
				.catch((error) => {
					console.error("Error adding addon to cart:", error)
					// Revert checkbox state on error
					checkbox.checked = false
					updateCheckboxVisual(false)
				})
		}
		if (!isChecked) {
			fetch(window.Shopify.routes.root + "cart.js")
				.then((response) => response.json())
				.then((cart) => {
					const addonItem = cart.items.find((item) => item.variant_id == addonVariantId)

					if (addonItem && addonItem.quantity === 1) {
						const updateData = {
							updates: {
								[addonVariantId]: 0,
							},
						}

						return fetch(window.Shopify.routes.root + "cart/update.js", {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
							},
							body: JSON.stringify(updateData),
						})
					}
					return null
				})
				.then((response) => {
					if (response) {
						return response.json()
					}
					return null
				})
				.then((data) => {
					if (data) {
						// Show loading overlay before refresh
						showLoadingOverlay()
						// Refresh cart drawer to show updated cart without addon
						const cartDrawer = document.querySelector("cart-drawer")
						if (cartDrawer) {
							cartDrawer.refresh()
							// MutationObserver will automatically hide overlay and re-initialize checkbox when DOM updates
						}
					}
				})
				.catch((error) => {
					console.error("Error removing addon from cart:", error)
					// Revert checkbox state on error
					checkbox.checked = true
					updateCheckboxVisual(true)
				})
		}
	}

	function initializeCheckboxState(checkbox) {
		const { addonVariantId } = checkbox.dataset

		fetch(window.Shopify.routes.root + "cart.js")
			.then((response) => response.json())
			.then((cart) => {
				const addonItem = cart.items.find((item) => item.variant_id == addonVariantId)
				const isInCart = addonItem && addonItem.quantity > 0

				checkbox.checked = isInCart
				updateCheckboxVisual(isInCart)
			})
			.catch((error) => {
				console.error("Error checking cart for addon:", error)
				checkbox.checked = false
				updateCheckboxVisual(false)
			})
	}
})
